import { useSelector } from 'react-redux';
import { selectIsEventsPlatform } from '../../../redux/slices/platform/platformSlice';
import {
  selectSelectedEvent,
  selectSelectedWorkflowKey,
} from '../../../redux/slices/events/eventsSlice';
import { getActiveAndAvailablePlaybooks } from '../../../constants/agents/playbookOnboardingData';

// The backend's Folder/Campaign/SmartReply/Qualification APIs only accept
// eventId + workflowId as a pair (EVENT_WORKFLOW_PAIR_REQUIRED) — a workflow
// that isn't yet activated for the team has no DB id, so it can't be scoped.
function useEventScope() {
  const isEventsPlatform = useSelector(selectIsEventsPlatform);
  const selectedEvent = useSelector(selectSelectedEvent);
  const selectedWorkflowKey = useSelector(selectSelectedWorkflowKey);
  const subscribedPlaybooks = useSelector(state => state.app.subscribedPlaybooks);

  const { activePlaybooksData } = getActiveAndAvailablePlaybooks(subscribedPlaybooks);
  const activeWorkflow = activePlaybooksData.find(item => item.key === selectedWorkflowKey);

  const eventId = selectedEvent?.id || null;
  const workflowId = activeWorkflow?.id || null;
  const isEventContext = Boolean(isEventsPlatform && eventId && workflowId);

  return {
    isEventContext,
    eventId: isEventContext ? eventId : null,
    workflowId: isEventContext ? workflowId : null,
    workflowKey: selectedWorkflowKey || null,
  };
}

export default useEventScope;
